module.exports = __webpack_public_path__ + "img/Back Wear.92e6b940.png";